export default __webpack_public_path__ + "static/media/default-avatar.f25f18b2.png";